<div class="project-summary-actions" *ngIf="actions.length > 0">
    <button mat-stroked-button [matMenuTriggerFor]="actionsMenu" class="actions-trigger action-secondary">
        Actions
        <mat-icon>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #actionsMenu="matMenu">
        <ng-container *ngFor="let action of actions">
            <button mat-menu-item *ngIf="actionVisible(action)" [disabled]="actionDisabled(action)"
                (click)="runAction(action, $event)">
                <span [ngClass]="{ 'action-danger-item': action.role === 'danger' }">{{ action.label }}</span>
            </button>
        </ng-container>
    </mat-menu>
</div>

<table mat-table [dataSource]="rows" class="w-100 project-summary-table">
    <ng-container matColumnDef="selected">
        <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox [checked]="isAllSelected()" (change)="toggleAll($event.checked)"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
            <button mat-icon-button *ngIf="row.excluded"
                (click)="requestRestore(row.projectID); $event.stopPropagation()" aria-label="Restore project">
                <mat-icon>undo</mat-icon>
            </button>
            <mat-checkbox *ngIf="!row.excluded" [checked]="isSelected(row.projectID)" (click)="$event.stopPropagation()"
                (change)="toggleProject(row.projectID, $event.checked)">
            </mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="new">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
            <mat-icon class="project-new-star" *ngIf="projectIsNew(row)">star</mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="projectName">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('ProjectName')"><span
                class="header-sort-label">Project Name&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('ProjectName')">{{ sortIcon('ProjectName') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.projectName }}</td>
    </ng-container>

    <ng-container matColumnDef="energySector">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('EnergySector')"><span
                class="header-sort-label">Sector&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('EnergySector')">{{ sortIcon('EnergySector') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.energySector }}</td>
    </ng-container>

    <ng-container matColumnDef="country">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('Country')"><span
                class="header-sort-label">Country&nbsp;<mat-icon class="sort-indicator" *ngIf="isSorted('Country')">{{
                    sortIcon('Country') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.country }}</td>
    </ng-container>

    <ng-container matColumnDef="companyName">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('CompanyName')"><span
                class="header-sort-label">Operator&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('CompanyName')">{{ sortIcon('CompanyName') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.companyName }}</td>
    </ng-container>

    <ng-container matColumnDef="dollarValue">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('DollarValue')"><span
                class="header-sort-label">Value ($M)&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('DollarValue')">{{ sortIcon('DollarValue') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ row.dollarValue | number: '1.0-0' }}</td>
    </ng-container>

    <ng-container matColumnDef="startupYear">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('StartupYear')"><span
                class="header-sort-label">Startup Year&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('StartupYear')">{{ sortIcon('StartupYear') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ row.startupYear }}</td>
    </ng-container>

    <ng-container matColumnDef="projectStage">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('ProjectStage')"><span
                class="header-sort-label">Project Stage&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('ProjectStage')">{{ sortIcon('ProjectStage') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.projectStage }}</td>
    </ng-container>

    <ng-container matColumnDef="projectStatus">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('ProjectStatus')"><span
                class="header-sort-label">Project Status&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('ProjectStatus')">{{ sortIcon('ProjectStatus') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.projectStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="trackingStatus">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('TrackingStatus')"><span
                class="header-sort-label">Tracking Status&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('TrackingStatus')">{{ sortIcon('TrackingStatus') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row">{{ row.trackingStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="projectUpdated">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('ProjectUpdated')"><span
                class="header-sort-label">Updated&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('ProjectUpdated')">{{ sortIcon('ProjectUpdated') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ row.projectUpdated | date: 'dd MMM yyyy' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"
        [class.project-excluded]="row.excluded" [class.project-updated-highlight]="projectUpdatedAfterHeadingDate(row)">
    </tr>
</table>